export const ShareType = {
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
} as const;

// eslint-disable-next-line -- intentionally naming the object the same as the type
export type ShareType = typeof ShareType[keyof typeof ShareType];